import { render, staticRenderFns } from "./index-logo-list.vue?vue&type=template&id=22ea57a7&scoped=true&ref=indexLogoList&"
import script from "./index-logo-list.vue?vue&type=script&lang=js&"
export * from "./index-logo-list.vue?vue&type=script&lang=js&"
import style0 from "./index-logo-list.vue?vue&type=style&index=0&id=22ea57a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea57a7",
  null
  
)

export default component.exports